// Manual translations for Casa Romano — EN, ES, FR, DE, RU, ZH, IT, PT
// rooms.list is indexed to ROOMS_META in data/site.js

export const translations = {
  en: {
    nav: { rooms: "Rooms", included: "Included", story: "Our Story", gallery: "Gallery", location: "Location", reviews: "Reviews", book: "Book Now" },
    hero: {
      kicker: "Hostal · San Juan del Sur, Nicaragua",
      titleTW: "Our family welcomes you to Casa Romano in San Juan del Sur!",
      l1: "A local family,",
      l2: "an open door,",
      l3: "your Pacific home.",
      sub: "Private rooms with private bathrooms, a shared kitchen and honest local advice — half a block from the beach in the heart of San Juan del Sur.",
      book: "Book Now",
      directions: "Directions",
      ratingLabel: "Google reviews",
    },
    marquee: ["Private Rooms", "Shared Kitchen", "Beach 2 min", "Local Family", "Free Wi-Fi", "San Juan del Sur"],
    story: {
      kicker: "Our Story",
      title: "We open our home to travelers from all over the world.",
      chapters: [
        { n: "01", t: "A local family", b: "Casa Romano is not a chain. We are a Nicaraguan family who opens the doors of our house to receive travelers with warmth, calm and a genuine welcome." },
        { n: "02", t: "Private comfort", b: "Enjoy private rooms with their own bathroom, high-speed Wi-Fi, and a fully equipped shared kitchen — comfort and independence in equal measure." },
        { n: "03", t: "The heart of San Juan", b: "Steps from the beach, restaurants, shops and nightlife. We share our favourite local spots so you fall in love with San Juan del Sur." },
      ],
    },
    rooms: {
      kicker: "The Rooms",
      title: "Ways to stay",
      sub: "Every room is private, with its own bathroom and high-speed Wi-Fi.",
      roomLabel: { one: "room available", other: "rooms available" },
      soldOut: "Sold out",
      includedLabel: "Included",
      extras: ["Linens", "Towels", "Toilet paper", "Soap"],
      guests: "guests",
      book: "Reserve this room",
      whatsapp: "WhatsApp about this room",
      perNight: "/ night",
      list: [
        { name: "Double Standard Room with Fan", desc: "Comfortable and functional for couples or travelers looking for great value in the very centre of San Juan del Sur.", amenities: ["Double bed", "Private bathroom", "Fan", "Wardrobe", "First floor", "Wi-Fi"] },
        { name: "Double Standard Room - Air Conditioning", desc: "For those who want extra comfort. A fresh, private space to rest after exploring the beaches and surroundings.", amenities: ["Double bed", "Air conditioning", "Private bathroom", "Clothes rack", "First floor", "Wi-Fi"] },
        { name: "Double · AC + Shared Balcony", desc: "Designed for a little extra comfort and an outdoor space to relax, read and disconnect during your stay.", amenities: ["Double bed", "Air conditioning", "Private bathroom", "Clothes rack", "Wi-Fi", "Shared balcony"] },
        { name: "Triple Room", desc: "Perfect for small families or friends travelling together — a cozy, practical space for up to three people.", amenities: ["Double bed + single bed", "Private bathroom", "Fan", "Large wardrobe", "Wi-Fi"] },
        { name: "Quadruple Room", desc: "Our largest room, ideal for families or groups of up to four who want to share a comfortable, family stay.", amenities: ["2 single beds + 1 bunk bed", "Private bathroom", "Fan", "Wi-Fi", "Spacious layout", "Wardrobe"] },
        { name: "Double Standard Room - Air Conditioning + Shared Balcony", desc: "For those who want extra comfort. A fresh, private space to rest after exploring the beaches and surroundings.", amenities: ["Double bed", "Air conditioning", "Private bathroom", "Shared balcony", "Second floor", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "Included in your stay",
      title: "Everything you need to feel at home!",
      title2: "Book your stay with us today!",
      items: [
        "Private room with private bathroom",
        "High-speed Wi-Fi",
        "Air conditioning or fan (by room)",
        "Linens, towels, toilet paper and soap",
        "Equipped shared kitchen (coffee, sugar, salt & oil included)",
        "Common areas to rest and socialize",
        "Local recommendations and tourist info",
        "Central location: beach, restaurants, shops & nightlife",
      ],
    },
    location: {
      kicker: "Find us",
      title: "Half a block from Casa Oro, towards the beach",
      addressLabel: "Address",
      address: "Zona Central, from Casa Oro half a block towards the beach, San Juan del Sur, Nicaragua",
      body: "You'll find us in the vibrant purple building with yellow windows in the very centre of town — a two-minute walk from the sand.",
      directions: "Open in Google Maps",
      whatsapp: "Message us on WhatsApp",
    },
    reviews: {
      kicker: "Guest love",
      title: "Loved by travelers",
      rating: "4.4",
      count: "Based on 98 Google reviews",
      readAll: "Read all reviews",
      leave: "Leave a review",
      items: [
        { name: "Backpacker · Canada", text: "Super central, spotless private room and the family made us feel at home from minute one. Kitchen is a huge plus." },
        { name: "Couple · Germany", text: "Great location half a block from the beach, quiet AC room and the best local tips for surfing and food." },
        { name: "Solo traveler · Italy", text: "Warm, honest and affordable. Exactly the calm, close experience they promise. I'd stay again in a heartbeat." },
      ],
    },
    aboutUs: {
      kicker: "About Us",
      title: "A family home, open since 2010",
      body: [
        "We're a Nicaraguan family who, encouraged by demand, decided to open the doors of our home to travelers back in 2010.",
        "In those years, San Juan del Sur was just beginning to grow as a destination, but places to stay in town were scarce. Since today's booking platforms didn't exist yet, travelers would walk the streets asking house to house for somewhere to sleep. They often knocked on ours, drawn in by how lovely our space looked.",
        "That's how we decided to adapt our house and turn it into what is now Casa Romano. Ever since, we've welcomed people from all over the world, turning every visit into a chance to share and make new friends.",
        "We built this space so you can reach out and book directly with our family.",
      ],
    },
    book: {
      title: "Request your stay",
      sub: "Fill in your details and we'll reply directly on WhatsApp to confirm availability.",
      name: "Full name",
      namePh: "Your name",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Guests",
      room: "Room type",
      roomPh: "Choose a room",
      roomAny: "No preference",
      message: "Message (optional)",
      messagePh: "Anything we should know?",
      submit: "Send to WhatsApp",
      chatDirect: "Chat on WhatsApp instead",
      or: "or",
      wa_intro: "Hello Casa Romano! I'd like to request a stay:",
      wa_name: "Name",
      wa_checkin: "Check-in",
      wa_checkout: "Check-out",
      wa_guests: "Guests",
      wa_room: "Room",
      wa_msg: "Message",
      availChecking: "Checking availability…",
      availRangeError: "Check-out must be after check-in.",
      availRoomOk: "{room} is available for your dates!",
      availAllOk: "Rooms are available for your dates!",
      availRoomFull: "{room} is fully booked for these nights. Try different dates or chat with us.",
      availAllFull: "We're fully booked for these nights. Try different dates or chat with us on WhatsApp.",
      availSoldOut: "Sorry, those dates are fully booked. Please try different dates or message us on WhatsApp.",
      availSoldOutBtn: "Sold out for these dates",
    },
    footer: {
      tagline: "A local family opening its doors to San Juan del Sur.",
      contactTitle: "Contact",
      linksTitle: "Explore",
      followTitle: "Follow us",
      rights: "All rights reserved.",
      ownerLogin: "Owner login",
    },
    wa_float: "Chat with us",
  },

  es: {
    nav: { rooms: "Habitaciones", included: "Incluido", story: "Nuestra historia", gallery: "Galería", location: "Ubicación", reviews: "Reseñas", book: "Reservar" },
    hero: {
      kicker: "Hostal · San Juan del Sur, Nicaragua",
      titleTW: "¡Nuestra familia te da la bienvenida a Casa Romano en San Juan del Sur!",
      l1: "Una familia local,",
      l2: "una puerta abierta,",
      l3: "tu hogar en el Pacífico.",
      sub: "Habitaciones privadas con baño propio, cocina compartida y recomendaciones locales — a media cuadra de la playa, en el centro de San Juan del Sur.",
      book: "Reservar",
      directions: "Cómo llegar",
      ratingLabel: "Reseñas de Google",
    },
    marquee: ["Habitaciones privadas", "Cocina compartida", "Playa a 2 min", "Familia local", "Wi-Fi gratis", "San Juan del Sur"],
    story: {
      kicker: "Nuestra historia",
      title: "Abrimos nuestro hogar a viajeros de todo el mundo.",
      chapters: [
        { n: "01", t: "Una familia local", b: "Casa Romano no es una cadena. Somos una familia nicaragüense que abre las puertas de su hogar para recibir viajeros con calidez, calma y una bienvenida auténtica." },
        { n: "02", t: "Confort privado", b: "Disfruta de habitaciones privadas con baño propio, Wi-Fi de alta velocidad y una cocina compartida totalmente equipada — comodidad e independencia por igual." },
        { n: "03", t: "El corazón de San Juan", b: "A pasos de la playa, restaurantes, tiendas y vida nocturna. Compartimos nuestros lugares favoritos para que te enamores de San Juan del Sur." },
      ],
    },
    rooms: {
      kicker: "Las habitaciones",
      title: "Formas de alojarte",
      sub: "Cada habitación es privada, con baño propio y Wi-Fi de alta velocidad.",
      roomLabel: { one: "habitación disponible", other: "habitaciones disponibles" },
      soldOut: "Agotado",
      includedLabel: "Incluido",
      extras: ["Sábanas", "Toallas", "Papel higiénico", "Jabón"],
      guests: "personas",
      book: "Reservar esta habitación",
      whatsapp: "Consultar por WhatsApp",
      perNight: "/ noche",
      list: [
        { name: "Habitación Doble Estándar con Abanico", desc: "Cómoda y funcional para parejas o viajeros que buscan una excelente relación calidad-precio en pleno centro de San Juan del Sur.", amenities: ["Cama doble", "Baño privado", "Ventilador", "Ropero", "Primer piso", "Wi-Fi"] },
        { name: "Habitación Doble Estándar - Aire Acondicionado", desc: "Para quienes buscan mayor confort. Un espacio fresco y privado para descansar tras explorar las playas y los alrededores.", amenities: ["Cama doble", "Aire acondicionado", "Baño privado", "Perchero", "Primer piso", "Wi-Fi"] },
        { name: "Doble · A/C + Balcón Compartido", desc: "Diseñada para un extra de comodidad y un espacio al aire libre para relajarte, leer y desconectar durante tu estancia.", amenities: ["Cama doble", "Aire acondicionado", "Baño privado", "Perchero", "Wi-Fi", "Balcón compartido"] },
        { name: "Habitación Triple", desc: "Perfecta para familias pequeñas o amigos que viajan juntos — un espacio acogedor y práctico para hasta 3 personas.", amenities: ["Cama doble + cama individual", "Baño privado", "Ventilador", "Ropero amplio", "Wi-Fi"] },
        { name: "Habitación Cuádruple", desc: "Nuestra habitación más amplia, ideal para familias o grupos de hasta 4 personas que quieren compartir una estancia cómoda.", amenities: ["2 camas individuales + 1 litera", "Baño privado", "Ventilador", "Wi-Fi", "Espacio amplio", "Ropero"] },
        { name: "Habitación Doble Estándar - Aire Acondicionado + Balcón compartido", desc: "Para quienes buscan mayor confort. Un espacio fresco y privado para descansar tras explorar las playas y los alrededores.", amenities: ["Cama doble", "Aire acondicionado", "Baño privado", "Balcón compartido", "Segundo piso", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "Incluido en tu estancia",
      title: "¡Todo lo que necesitas para sentirte como en casa!",
      title2: "¡Reserva tu estancia con nosotros hoy!",
      items: [
        "Habitación privada con baño privado",
        "Wi-Fi de alta velocidad",
        "Aire acondicionado o ventilador (según la habitación)",
        "Ropa de cama, toallas, papel higiénico y jabón",
        "Cocina compartida equipada (café, azúcar, sal y aceite incluidos)",
        "Áreas comunes para descansar y convivir",
        "Recomendaciones locales e información turística",
        "Ubicación céntrica: playa, restaurantes, tiendas y vida nocturna",
      ],
    },
    location: {
      kicker: "Encuéntranos",
      title: "A media cuadra de Casa Oro, hacia la playa",
      addressLabel: "Dirección",
      address: "Zona Central, de Casa Oro media cuadra hacia la playa, San Juan del Sur, Nicaragua",
      body: "Nos encontrarás en el vibrante edificio morado con ventanas amarillas, en pleno centro — a dos minutos caminando de la arena.",
      directions: "Abrir en Google Maps",
      whatsapp: "Escríbenos por WhatsApp",
    },
    reviews: {
      kicker: "Nuestros huéspedes",
      title: "Amado por los viajeros",
      rating: "4.4",
      count: "Basado en 98 reseñas de Google",
      readAll: "Ver todas las reseñas",
      leave: "Dejar una reseña",
      items: [
        { name: "Mochilero · Canadá", text: "Súper céntrico, habitación privada impecable y la familia nos hizo sentir en casa desde el primer minuto. La cocina es un gran plus." },
        { name: "Pareja · Alemania", text: "Excelente ubicación a media cuadra de la playa, habitación con A/C tranquila y los mejores consejos locales para surfear y comer." },
        { name: "Viajera sola · Italia", text: "Cálido, honesto y accesible. Exactamente la experiencia tranquila y cercana que prometen. Volvería sin dudarlo." },
      ],
    },
    aboutUs: {
      kicker: "Sobre nosotros",
      title: "Una casa de familia, abierta desde 2010",
      body: [
        "Somos una familia nicaragüense que, impulsada por la demanda, decidió abrir las puertas de su hogar a los viajeros en el año 2010.",
        "En aquellos años, San Juan del Sur estaba empezando a ser un destino turístico cada vez más conocido, pero la oferta de hospedaje en el pueblo era limitada. Como aún no existían las plataformas digitales de hoy, los viajeros recorrían las calles preguntando en las casas en busca de un lugar donde hospedarse. A la nuestra, específicamente, llegaban con frecuencia preguntando si ofrecíamos ese servicio, atraídos por lo bonito de nuestro espacio.",
        "Fue así como decidimos adaptar nuestra casa para convertirla en lo que hoy es Casa Romano. Desde entonces, hemos recibido a personas de todo el mundo, convirtiendo cada visita en una oportunidad para compartir y hacer amistades.",
        "Creamos este espacio para que puedas contactarte y reservar directamente con nuestra familia.",
      ],
    },
    book: {
      title: "Solicita tu estancia",
      sub: "Completa tus datos y te responderemos directamente por WhatsApp para confirmar disponibilidad.",
      name: "Nombre completo",
      namePh: "Tu nombre",
      checkin: "Entrada",
      checkout: "Salida",
      guests: "Personas",
      room: "Tipo de habitación",
      roomPh: "Elige una habitación",
      roomAny: "Sin preferencia",
      message: "Mensaje (opcional)",
      messagePh: "¿Algo que debamos saber?",
      submit: "Enviar por WhatsApp",
      chatDirect: "O escríbenos directo por WhatsApp",
      or: "o",
      wa_intro: "¡Hola Casa Romano! Quisiera solicitar una estancia:",
      wa_name: "Nombre",
      wa_checkin: "Entrada",
      wa_checkout: "Salida",
      wa_guests: "Personas",
      wa_room: "Habitación",
      wa_msg: "Mensaje",
      availChecking: "Comprobando disponibilidad…",
      availRangeError: "La salida debe ser posterior a la entrada.",
      availRoomOk: "¡{room} está disponible para tus fechas!",
      availAllOk: "¡Hay habitaciones disponibles para tus fechas!",
      availRoomFull: "{room} está completo esas noches. Prueba otras fechas o escríbenos.",
      availAllFull: "Estamos completos esas noches. Prueba otras fechas o escríbenos por WhatsApp.",
      availSoldOut: "Lo sentimos, esas fechas están completas. Prueba otras fechas o escríbenos por WhatsApp.",
      availSoldOutBtn: "Agotado en estas fechas",
    },
    footer: {
      tagline: "Una familia local que abre sus puertas a San Juan del Sur.",
      contactTitle: "Contacto",
      linksTitle: "Explorar",
      followTitle: "Síguenos",
      ownerLogin: "Acceso propietario",
      rights: "Todos los derechos reservados.",
    },
    wa_float: "Escríbenos",
  },

  fr: {
    nav: { rooms: "Chambres", included: "Inclus", story: "Notre histoire", gallery: "Galerie", location: "Emplacement", reviews: "Avis", book: "Réserver" },
    hero: {
      kicker: "Auberge · San Juan del Sur, Nicaragua",
      titleTW: "Notre famille vous accueille à Casa Romano à San Juan del Sur !",
      l1: "Une famille locale,",
      l2: "une porte ouverte,",
      l3: "votre maison du Pacifique.",
      sub: "Chambres privées avec salle de bain, cuisine partagée et conseils locaux — à un demi-pâté de maisons de la plage, au cœur de San Juan del Sur.",
      book: "Réserver",
      directions: "Itinéraire",
      ratingLabel: "avis Google",
    },
    marquee: ["Chambres privées", "Cuisine partagée", "Plage à 2 min", "Famille locale", "Wi-Fi gratuit", "San Juan del Sur"],
    story: {
      kicker: "Notre histoire",
      title: "Nous ouvrons notre maison aux voyageurs du monde entier.",
      chapters: [
        { n: "01", t: "Une famille locale", b: "Casa Romano n'est pas une chaîne. Nous sommes une famille nicaraguayenne qui ouvre les portes de sa maison pour accueillir les voyageurs avec chaleur, calme et une bienvenue authentique." },
        { n: "02", t: "Confort privé", b: "Profitez de chambres privées avec salle de bain, d'un Wi-Fi haut débit et d'une cuisine partagée entièrement équipée — confort et indépendance à la fois." },
        { n: "03", t: "Le cœur de San Juan", b: "À quelques pas de la plage, des restaurants, des boutiques et de la vie nocturne. Nous partageons nos adresses préférées pour que vous tombiez amoureux de San Juan del Sur." },
      ],
    },
    rooms: {
      kicker: "Les chambres",
      title: "Cinq façons de séjourner",
      sub: "Chaque chambre est privée, avec sa propre salle de bain et un Wi-Fi haut débit.",
      roomLabel: { one: "chambre disponible", other: "chambres disponibles" },
      soldOut: "Complet",
      includedLabel: "Inclus",
      extras: ["Linge de lit", "Serviettes", "Papier toilette", "Savon"],
      guests: "personnes",
      book: "Réserver cette chambre",
      whatsapp: "WhatsApp pour cette chambre",
      perNight: "/ nuit",
      list: [
        { name: "Chambre Double Standard avec Ventilateur", desc: "Confortable et fonctionnelle pour les couples ou voyageurs cherchant un excellent rapport qualité-prix en plein centre de San Juan del Sur.", amenities: ["Lit double", "Salle de bain privée", "Ventilateur", "Armoire", "Premier étage", "Wi-Fi"] },
        { name: "Chambre Double Standard - Climatisation", desc: "Pour ceux qui recherchent plus de confort. Un espace frais et privé pour se reposer après avoir exploré les plages et les environs.", amenities: ["Lit double", "Climatisation", "Salle de bain privée", "Porte-manteau", "Premier étage", "Wi-Fi"] },
        { name: "Double · Clim + Balcon Partagé", desc: "Conçue pour un confort supplémentaire et un espace extérieur pour se détendre, lire et déconnecter durant votre séjour.", amenities: ["Lit double", "Climatisation", "Salle de bain privée", "Porte-manteau", "Wi-Fi", "Balcon partagé"] },
        { name: "Chambre Triple", desc: "Parfaite pour les petites familles ou les amis voyageant ensemble — un espace chaleureux et pratique pour 3 personnes.", amenities: ["Lit double + lit simple", "Salle de bain privée", "Ventilateur", "Grande armoire", "Wi-Fi"] },
        { name: "Chambre Quadruple", desc: "Notre plus grande chambre, idéale pour les familles ou groupes de 4 personnes souhaitant partager un séjour confortable.", amenities: ["2 lits simples + 1 lit superposé", "Salle de bain privée", "Ventilateur", "Wi-Fi", "Espace spacieux", "Armoire"] },
        { name: "Chambre Double Standard - Climatisation + Balcon partagé", desc: "Pour ceux qui recherchent plus de confort. Un espace frais et privé pour se reposer après avoir exploré les plages et les environs.", amenities: ["Lit double", "Climatisation", "Salle de bain privée", "Balcon partagé", "Deuxième étage", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "Inclus dans votre séjour",
      title: "Tout ce qu'il faut pour vous sentir chez vous !",
      title2: "Réservez votre séjour chez nous dès aujourd'hui !",
      items: [
        "Chambre privée avec salle de bain privée",
        "Wi-Fi haut débit",
        "Climatisation ou ventilateur (selon la chambre)",
        "Draps, serviettes, papier toilette et savon",
        "Cuisine partagée équipée (café, sucre, sel et huile inclus)",
        "Espaces communs pour se reposer et échanger",
        "Recommandations locales et infos touristiques",
        "Emplacement central : plage, restaurants, boutiques et vie nocturne",
      ],
    },
    location: {
      kicker: "Nous trouver",
      title: "À un demi-pâté de maisons de Casa Oro, vers la plage",
      addressLabel: "Adresse",
      address: "Zona Central, de Casa Oro un demi-pâté de maisons vers la plage, San Juan del Sur, Nicaragua",
      body: "Vous nous trouverez dans le bâtiment violet vif aux fenêtres jaunes, en plein centre — à deux minutes à pied du sable.",
      directions: "Ouvrir dans Google Maps",
      whatsapp: "Écrivez-nous sur WhatsApp",
    },
    reviews: {
      kicker: "Nos voyageurs",
      title: "Adoré par les voyageurs",
      rating: "4.4",
      count: "Basé sur 98 avis Google",
      readAll: "Voir tous les avis",
      leave: "Laisser un avis",
      items: [
        { name: "Routard · Canada", text: "Très central, chambre privée impeccable et la famille nous a mis à l'aise dès la première minute. La cuisine est un vrai plus." },
        { name: "Couple · Allemagne", text: "Super emplacement à un demi-pâté de la plage, chambre climatisée calme et les meilleurs conseils locaux pour le surf et la cuisine." },
        { name: "Voyageuse solo · Italie", text: "Chaleureux, honnête et abordable. Exactement l'expérience calme et proche qu'ils promettent. J'y retournerais sans hésiter." },
      ],
    },
    aboutUs: {
      kicker: "À propos",
      title: "Une maison de famille, ouverte depuis 2010",
      body: [
        "Nous sommes une famille nicaraguayenne qui, poussée par la demande, a décidé d'ouvrir les portes de sa maison aux voyageurs en 2010.",
        "À cette époque, San Juan del Sur commençait à peine à devenir une destination connue, mais les hébergements en ville étaient rares. Comme les plateformes de réservation d'aujourd'hui n'existaient pas encore, les voyageurs parcouraient les rues en frappant aux portes à la recherche d'un endroit où dormir. On venait souvent chez nous, séduit par la beauté de notre espace.",
        "C'est ainsi que nous avons décidé d'adapter notre maison pour en faire ce qu'est aujourd'hui Casa Romano. Depuis, nous accueillons des personnes du monde entier, transformant chaque visite en une occasion de partager et de nouer des amitiés.",
        "Nous avons créé cet espace pour que vous puissiez nous contacter et réserver directement auprès de notre famille.",
      ],
    },
    book: {
      title: "Demandez votre séjour",
      sub: "Remplissez vos informations et nous vous répondrons directement sur WhatsApp pour confirmer la disponibilité.",
      name: "Nom complet",
      namePh: "Votre nom",
      checkin: "Arrivée",
      checkout: "Départ",
      guests: "Personnes",
      room: "Type de chambre",
      roomPh: "Choisir une chambre",
      roomAny: "Sans préférence",
      message: "Message (facultatif)",
      messagePh: "Quelque chose à nous signaler ?",
      submit: "Envoyer sur WhatsApp",
      chatDirect: "Ou écrivez-nous directement sur WhatsApp",
      or: "ou",
      wa_intro: "Bonjour Casa Romano ! Je souhaite demander un séjour :",
      wa_name: "Nom",
      wa_checkin: "Arrivée",
      wa_checkout: "Départ",
      wa_guests: "Personnes",
      wa_room: "Chambre",
      wa_msg: "Message",
      availChecking: "Vérification des disponibilités…",
      availRangeError: "Le départ doit être après l'arrivée.",
      availRoomOk: "{room} est disponible pour vos dates !",
      availAllOk: "Des chambres sont disponibles pour vos dates !",
      availRoomFull: "{room} est complet pour ces nuits. Essayez d'autres dates ou écrivez-nous.",
      availAllFull: "Nous sommes complets pour ces nuits. Essayez d'autres dates ou écrivez-nous sur WhatsApp.",
      availSoldOut: "Désolé, ces dates sont complètes. Essayez d'autres dates ou écrivez-nous sur WhatsApp.",
      availSoldOutBtn: "Complet pour ces dates",
    },
    footer: {
      tagline: "Une famille locale qui ouvre ses portes à San Juan del Sur.",
      contactTitle: "Contact",
      linksTitle: "Explorer",
      ownerLogin: "Connexion propriétaire",
      followTitle: "Suivez-nous",
      rights: "Tous droits réservés.",
    },
    wa_float: "Écrivez-nous",
  },

  de: {
    nav: { rooms: "Zimmer", included: "Inklusive", story: "Unsere Geschichte", gallery: "Galerie", location: "Lage", reviews: "Bewertungen", book: "Buchen" },
    hero: {
      kicker: "Hostel · San Juan del Sur, Nicaragua",
      titleTW: "Unsere Familie heißt dich im Casa Romano in San Juan del Sur willkommen!",
      l1: "Eine lokale Familie,",
      l2: "eine offene Tür,",
      l3: "dein Zuhause am Pazifik.",
      sub: "Private Zimmer mit eigenem Bad, Gemeinschaftsküche und ehrlichen lokalen Tipps — einen halben Block vom Strand, im Herzen von San Juan del Sur.",
      book: "Buchen",
      directions: "Route",
      ratingLabel: "Google-Bewertungen",
    },
    marquee: ["Private Zimmer", "Gemeinschaftsküche", "Strand 2 Min", "Lokale Familie", "Gratis WLAN", "San Juan del Sur"],
    story: {
      kicker: "Unsere Geschichte",
      title: "Wir öffnen unser Zuhause für Reisende aus aller Welt.",
      chapters: [
        { n: "01", t: "Eine lokale Familie", b: "Casa Romano ist keine Kette. Wir sind eine nicaraguanische Familie, die die Türen ihres Hauses öffnet, um Reisende mit Wärme, Ruhe und echtem Willkommen zu empfangen." },
        { n: "02", t: "Privater Komfort", b: "Genieße private Zimmer mit eigenem Bad, schnelles WLAN und eine voll ausgestattete Gemeinschaftsküche — Komfort und Unabhängigkeit zugleich." },
        { n: "03", t: "Das Herz von San Juan", b: "Nur wenige Schritte von Strand, Restaurants, Läden und Nachtleben. Wir teilen unsere Lieblingsorte, damit du dich in San Juan del Sur verliebst." },
      ],
    },
    rooms: {
      kicker: "Die Zimmer",
      title: "Unsere Zimmer",
      sub: "Jedes Zimmer ist privat, mit eigenem Bad und schnellem WLAN.",
      roomLabel: { one: "Zimmer verfügbar", other: "Zimmer verfügbar" },
      soldOut: "Ausgebucht",
      includedLabel: "Inklusive",
      extras: ["Bettwäsche", "Handtücher", "Toilettenpapier", "Seife"],
      guests: "Gäste",
      book: "Dieses Zimmer reservieren",
      whatsapp: "Per WhatsApp anfragen",
      perNight: "/ Nacht",
      list: [
        { name: "Standard-Doppelzimmer mit Ventilator", desc: "Komfortabel und funktional für Paare oder Reisende, die ein hervorragendes Preis-Leistungs-Verhältnis im Zentrum von San Juan del Sur suchen.", amenities: ["Doppelbett", "Eigenes Bad", "Ventilator", "Kleiderschrank", "Erster Stock", "WLAN"] },
        { name: "Standard-Doppelzimmer - Klimaanlage", desc: "Für alle, die mehr Komfort wünschen. Ein kühler, privater Rückzugsort nach dem Erkunden der Strände und Umgebung.", amenities: ["Doppelbett", "Klimaanlage", "Eigenes Bad", "Kleiderständer", "Erster Stock", "WLAN"] },
        { name: "Doppel · Klima + Gemeinschaftsbalkon", desc: "Für etwas mehr Komfort und einen Außenbereich zum Entspannen, Lesen und Abschalten während deines Aufenthalts.", amenities: ["Doppelbett", "Klimaanlage", "Eigenes Bad", "Kleiderständer", "WLAN", "Gemeinschaftsbalkon"] },
        { name: "Dreibettzimmer", desc: "Perfekt für kleine Familien oder Freunde, die zusammen reisen — ein gemütlicher, praktischer Raum für bis zu 3 Personen.", amenities: ["Doppelbett + Einzelbett", "Eigenes Bad", "Ventilator", "Großer Kleiderschrank", "WLAN"] },
        { name: "Vierbettzimmer", desc: "Unser größtes Zimmer, ideal für Familien oder Gruppen von bis zu 4 Personen, die einen komfortablen Aufenthalt teilen möchten.", amenities: ["2 Einzelbetten + 1 Etagenbett", "Eigenes Bad", "Ventilator", "WLAN", "Viel Platz", "Kleiderschrank"] },
        { name: "Standard-Doppelzimmer - Klimaanlage + Gemeinschaftsbalkon", desc: "Für alle, die mehr Komfort wünschen. Ein kühler, privater Rückzugsort nach dem Erkunden der Strände und Umgebung.", amenities: ["Doppelbett", "Klimaanlage", "Eigenes Bad", "Gemeinschaftsbalkon", "Zweiter Stock", "WLAN"] },
      ],
    },
    included: {
      kicker: "In deinem Aufenthalt enthalten",
      title: "Alles, was du brauchst, um dich wie zu Hause zu fühlen!",
      title2: "Buche deinen Aufenthalt noch heute bei uns!",
      items: [
        "Privates Zimmer mit eigenem Bad",
        "Schnelles WLAN",
        "Klimaanlage oder Ventilator (je nach Zimmer)",
        "Bettwäsche, Handtücher, Toilettenpapier und Seife",
        "Ausgestattete Gemeinschaftsküche (Kaffee, Zucker, Salz & Öl inklusive)",
        "Gemeinschaftsbereiche zum Ausruhen und Beisammensein",
        "Lokale Empfehlungen und Touristeninfos",
        "Zentrale Lage: Strand, Restaurants, Geschäfte & Nachtleben",
      ],
    },
    location: {
      kicker: "Finde uns",
      title: "Einen halben Block von Casa Oro, Richtung Strand",
      addressLabel: "Adresse",
      address: "Zona Central, von Casa Oro einen halben Block Richtung Strand, San Juan del Sur, Nicaragua",
      body: "Du findest uns im leuchtend lila Gebäude mit den gelben Fenstern, mitten im Zentrum — zwei Gehminuten vom Sand entfernt.",
      directions: "In Google Maps öffnen",
      whatsapp: "Schreib uns auf WhatsApp",
    },
    reviews: {
      kicker: "Unsere Gäste",
      title: "Von Reisenden geliebt",
      rating: "4.4",
      count: "Basierend auf 98 Google-Bewertungen",
      readAll: "Alle Bewertungen lesen",
      leave: "Bewertung abgeben",
      items: [
        { name: "Backpacker · Kanada", text: "Super zentral, makelloses Privatzimmer und die Familie ließ uns von der ersten Minute an wie zu Hause fühlen. Die Küche ist ein großes Plus." },
        { name: "Paar · Deutschland", text: "Tolle Lage, einen halben Block vom Strand, ruhiges Klimazimmer und die besten lokalen Tipps zum Surfen und Essen." },
        { name: "Alleinreisende · Italien", text: "Herzlich, ehrlich und günstig. Genau die ruhige, persönliche Erfahrung, die sie versprechen. Ich würde sofort wiederkommen." },
      ],
    },
    aboutUs: {
      kicker: "Über uns",
      title: "Ein Familienhaus, offen seit 2010",
      body: [
        "Wir sind eine nicaraguanische Familie, die 2010 – von der Nachfrage angeregt – beschloss, die Türen ihres Zuhauses für Reisende zu öffnen.",
        "Damals begann San Juan del Sur gerade, ein bekanntes Reiseziel zu werden, doch Unterkünfte im Ort waren knapp. Da es die heutigen Buchungsplattformen noch nicht gab, zogen Reisende durch die Straßen und fragten von Haus zu Haus nach einer Bleibe. Bei uns klopften sie oft an, angezogen von der Schönheit unseres Hauses.",
        "So entschieden wir uns, unser Haus umzugestalten und daraus das heutige Casa Romano zu machen. Seitdem heißen wir Menschen aus aller Welt willkommen und machen aus jedem Besuch eine Gelegenheit, zu teilen und Freundschaften zu schließen.",
        "Wir haben diesen Ort geschaffen, damit du uns kontaktieren und direkt bei unserer Familie buchen kannst.",
      ],
    },
    book: {
      title: "Aufenthalt anfragen",
      sub: "Fülle deine Daten aus und wir antworten direkt per WhatsApp, um die Verfügbarkeit zu bestätigen.",
      name: "Vollständiger Name",
      namePh: "Dein Name",
      checkin: "Anreise",
      checkout: "Abreise",
      guests: "Gäste",
      room: "Zimmertyp",
      roomPh: "Zimmer wählen",
      roomAny: "Keine Präferenz",
      message: "Nachricht (optional)",
      messagePh: "Sollten wir etwas wissen?",
      submit: "An WhatsApp senden",
      chatDirect: "Oder direkt per WhatsApp schreiben",
      or: "oder",
      wa_intro: "Hallo Casa Romano! Ich möchte einen Aufenthalt anfragen:",
      wa_name: "Name",
      wa_checkin: "Anreise",
      wa_checkout: "Abreise",
      wa_guests: "Gäste",
      wa_room: "Zimmer",
      wa_msg: "Nachricht",
      availChecking: "Verfügbarkeit wird geprüft…",
      availRangeError: "Die Abreise muss nach der Anreise liegen.",
      availRoomOk: "{room} ist für deine Daten verfügbar!",
      availAllOk: "Zimmer sind für deine Daten verfügbar!",
      availRoomFull: "{room} ist in diesen Nächten ausgebucht. Probiere andere Daten oder schreib uns.",
      availAllFull: "Wir sind in diesen Nächten ausgebucht. Probiere andere Daten oder schreib uns auf WhatsApp.",
      availSoldOut: "Leider sind diese Daten ausgebucht. Bitte probiere andere Daten oder schreib uns auf WhatsApp.",
      availSoldOutBtn: "Für diese Daten ausgebucht",
    },
    footer: {
      tagline: "Eine lokale Familie, die ihre Türen zu San Juan del Sur öffnet.",
      contactTitle: "Kontakt",
      linksTitle: "Entdecken",
      followTitle: "Folge uns",
      rights: "Alle Rechte vorbehalten.",
      ownerLogin: "Inhaber-Login",
    },
    wa_float: "Schreib uns",
  },

  ru: {
    nav: { rooms: "Номера", included: "Включено", story: "Наша история", gallery: "Галерея", location: "Расположение", reviews: "Отзывы", book: "Забронировать" },
    hero: {
      kicker: "Хостел · Сан-Хуан-дель-Сур, Никарагуа",
      titleTW: "Наша семья рада приветствовать вас в Casa Romano в Сан-Хуан-дель-Сур!",
      l1: "Местная семья,",
      l2: "открытая дверь,",
      l3: "ваш дом на Тихом океане.",
      sub: "Отдельные номера с собственной ванной, общая кухня и честные местные советы — в полуквартале от пляжа, в самом центре Сан-Хуан-дель-Сур.",
      book: "Забронировать",
      directions: "Маршрут",
      ratingLabel: "отзывов Google",
    },
    marquee: ["Отдельные номера", "Общая кухня", "Пляж 2 мин", "Местная семья", "Бесплатный Wi-Fi", "Сан-Хуан-дель-Сур"],
    story: {
      kicker: "Наша история",
      title: "Мы открываем наш дом для путешественников со всего мира.",
      chapters: [
        { n: "01", t: "Местная семья", b: "Casa Romano — не сеть отелей. Мы никарагуанская семья, которая открывает двери своего дома, чтобы встретить путешественников с теплом, спокойствием и искренним гостеприимством." },
        { n: "02", t: "Личный комфорт", b: "Отдельные номера с собственной ванной, скоростной Wi-Fi и полностью оборудованная общая кухня — комфорт и независимость одновременно." },
        { n: "03", t: "Сердце Сан-Хуана", b: "В нескольких шагах от пляжа, ресторанов, магазинов и ночной жизни. Мы делимся любимыми местами, чтобы вы влюбились в Сан-Хуан-дель-Сур." },
      ],
    },
    rooms: {
      kicker: "Номера",
      title: "Варианты размещения",
      sub: "Каждый номер отдельный, с собственной ванной и скоростным Wi-Fi.",
      roomLabel: { one: "номер доступен", other: "номера доступно" },
      soldOut: "Мест нет",
      includedLabel: "Включено",
      extras: ["Постельное бельё", "Полотенца", "Туалетная бумага", "Мыло"],
      guests: "гостей",
      book: "Забронировать этот номер",
      whatsapp: "Спросить в WhatsApp",
      perNight: "/ ночь",
      list: [
        { name: "Стандартный двухместный номер с вентилятором", desc: "Удобный и функциональный для пар или путешественников, ищущих отличное соотношение цены и качества в самом центре Сан-Хуан-дель-Сур.", amenities: ["Двуспальная кровать", "Собственная ванная", "Вентилятор", "Шкаф", "Первый этаж", "Wi-Fi"] },
        { name: "Стандартный двухместный номер - Кондиционер", desc: "Для тех, кто хочет больше комфорта. Прохладное личное пространство для отдыха после прогулок по пляжам и окрестностям.", amenities: ["Двуспальная кровать", "Кондиционер", "Собственная ванная", "Вешалка", "Первый этаж", "Wi-Fi"] },
        { name: "Двухместный · Кондиц. + общий балкон", desc: "Для дополнительного комфорта и открытого пространства, чтобы расслабиться, почитать и отдохнуть во время пребывания.", amenities: ["Двуспальная кровать", "Кондиционер", "Собственная ванная", "Вешалка", "Wi-Fi", "Общий балкон"] },
        { name: "Трёхместный номер", desc: "Идеально для небольших семей или друзей — уютное и практичное пространство для 3 человек.", amenities: ["Двуспальная + односпальная кровать", "Собственная ванная", "Вентилятор", "Большой шкаф", "Wi-Fi"] },
        { name: "Четырёхместный номер", desc: "Наш самый просторный номер, идеален для семей или групп до 4 человек, желающих комфортно разместиться вместе.", amenities: ["2 односпальные + 1 двухъярусная кровать", "Собственная ванная", "Вентилятор", "Wi-Fi", "Просторная планировка", "Шкаф"] },
        { name: "Стандартный двухместный номер - Кондиционер + Общий балкон", desc: "Для тех, кто хочет больше комфорта. Прохладное личное пространство для отдыха после прогулок по пляжам и окрестностям.", amenities: ["Двуспальная кровать", "Кондиционер", "Собственная ванная", "Общий балкон", "Второй этаж", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "Включено в проживание",
      title: "Всё, что нужно, чтобы почувствовать себя как дома!",
      title2: "Забронируйте проживание у нас уже сегодня!",
      items: [
        "Отдельный номер с собственной ванной",
        "Скоростной Wi-Fi",
        "Кондиционер или вентилятор (по номеру)",
        "Постельное бельё, полотенца, туалетная бумага и мыло",
        "Оборудованная общая кухня (кофе, сахар, соль и масло включены)",
        "Общие зоны для отдыха и общения",
        "Местные рекомендации и туристическая информация",
        "Центральное расположение: пляж, рестораны, магазины и ночная жизнь",
      ],
    },
    location: {
      kicker: "Найти нас",
      title: "В полуквартале от Casa Oro, в сторону пляжа",
      addressLabel: "Адрес",
      address: "Zona Central, от Casa Oro полквартала в сторону пляжа, Сан-Хуан-дель-Сур, Никарагуа",
      body: "Вы найдёте нас в ярко-фиолетовом здании с жёлтыми окнами в самом центре — в двух минутах ходьбы от песка.",
      directions: "Открыть в Google Maps",
      whatsapp: "Напишите нам в WhatsApp",
    },
    reviews: {
      kicker: "Наши гости",
      title: "Любим путешественниками",
      rating: "4.4",
      count: "На основе 98 отзывов Google",
      readAll: "Читать все отзывы",
      leave: "Оставить отзыв",
      items: [
        { name: "Бэкпекер · Канада", text: "Очень центрально, безупречный отдельный номер, и семья с первой минуты сделала так, что мы почувствовали себя как дома. Кухня — большой плюс." },
        { name: "Пара · Германия", text: "Отличное расположение в полуквартале от пляжа, тихий номер с кондиционером и лучшие местные советы по сёрфингу и еде." },
        { name: "Одиночное путешествие · Италия", text: "Тепло, честно и доступно. Именно тот спокойный и близкий опыт, который они обещают. Вернулась бы не раздумывая." },
      ],
    },
    aboutUs: {
      kicker: "О нас",
      title: "Семейный дом, открытый с 2010 года",
      body: [
        "Мы — никарагуанская семья, которая в 2010 году, откликнувшись на спрос, решила открыть двери своего дома для путешественников.",
        "В те годы Сан-Хуан-дель-Сур только начинал становиться известным направлением, а жилья в городке было мало. Сегодняшних платформ бронирования ещё не существовало, поэтому путешественники ходили по улицам и стучались в дома в поисках ночлега. К нам заходили особенно часто, привлечённые красотой нашего дома.",
        "Так мы решили преобразить наш дом и превратить его в то, что сегодня называется Casa Romano. С тех пор мы принимаем гостей со всего мира, превращая каждый визит в возможность общаться и заводить друзей.",
        "Мы создали это пространство, чтобы вы могли связаться и забронировать напрямую у нашей семьи.",
      ],
    },
    book: {
      title: "Запрос на проживание",
      sub: "Заполните данные, и мы ответим напрямую в WhatsApp, чтобы подтвердить наличие мест.",
      name: "Полное имя",
      namePh: "Ваше имя",
      checkin: "Заезд",
      checkout: "Выезд",
      guests: "Гостей",
      room: "Тип номера",
      roomPh: "Выберите номер",
      roomAny: "Без предпочтений",
      message: "Сообщение (необязательно)",
      messagePh: "Есть что-то, что нам стоит знать?",
      submit: "Отправить в WhatsApp",
      chatDirect: "Или напишите напрямую в WhatsApp",
      or: "или",
      wa_intro: "Здравствуйте, Casa Romano! Хочу оставить запрос на проживание:",
      wa_name: "Имя",
      wa_checkin: "Заезд",
      wa_checkout: "Выезд",
      wa_guests: "Гостей",
      wa_room: "Номер",
      wa_msg: "Сообщение",
      availChecking: "Проверяем наличие мест…",
      availRangeError: "Дата выезда должна быть позже даты заезда.",
      availRoomOk: "{room} доступен на выбранные даты!",
      availAllOk: "Есть свободные номера на выбранные даты!",
      availRoomFull: "{room} занят на эти ночи. Попробуйте другие даты или напишите нам.",
      availAllFull: "На эти ночи всё занято. Попробуйте другие даты или напишите нам в WhatsApp.",
      availSoldOut: "К сожалению, на эти даты всё занято. Попробуйте другие даты или напишите нам в WhatsApp.",
      availSoldOutBtn: "Нет мест на эти даты",
    },
    footer: {
      tagline: "Местная семья, открывающая двери в Сан-Хуан-дель-Сур.",
      contactTitle: "Контакты",
      linksTitle: "Разделы",
      followTitle: "Мы в соцсетях",
      ownerLogin: "Вход для владельца",
      rights: "Все права защищены.",
    },
    wa_float: "Напишите нам",
  },

  zh: {
    nav: { rooms: "客房", included: "包含", story: "我们的故事", gallery: "相册", location: "位置", reviews: "评价", book: "立即预订" },
    hero: {
      kicker: "旅舍 · 尼加拉瓜 圣胡安德尔苏尔",
      titleTW: "我们全家欢迎您来到圣胡安德尔苏尔的 Casa Romano！",
      l1: "一个本地家庭，",
      l2: "一扇敞开的门，",
      l3: "你的太平洋之家。",
      sub: "独立卫浴的私人客房、共享厨房与真诚的当地建议——距海滩半个街区，就在圣胡安德尔苏尔的中心。",
      book: "立即预订",
      directions: "路线",
      ratingLabel: "谷歌评价",
    },
    marquee: ["私人客房", "共享厨房", "海滩2分钟", "本地家庭", "免费Wi-Fi", "圣胡安德尔苏尔"],
    story: {
      kicker: "我们的故事",
      title: "我们向来自世界各地的旅行者敞开家门。",
      chapters: [
        { n: "01", t: "本地家庭", b: "Casa Romano 不是连锁酒店。我们是一个尼加拉瓜家庭，敞开家门以温暖、宁静和真诚的欢迎接待旅行者。" },
        { n: "02", t: "私享舒适", b: "享受配有独立卫浴的私人客房、高速Wi-Fi以及设备齐全的共享厨房——舒适与自在兼得。" },
        { n: "03", t: "圣胡安的心脏地带", b: "距海滩、餐厅、商店和夜生活仅几步之遥。我们分享最爱的当地去处，让你爱上圣胡安德尔苏尔。" },
      ],
    },
    rooms: {
      kicker: "客房",
      title: "入住方式",
      sub: "每间客房均为私人客房，配有独立卫浴和高速Wi-Fi。",
      roomLabel: { one: "间可预订", other: "间可预订" },
      soldOut: "已订满",
      includedLabel: "含",
      extras: ["床单", "毛巾", "卫生纸", "香皂"],
      guests: "位客人",
      book: "预订此房间",
      whatsapp: "通过 WhatsApp 咨询",
      perNight: "/ 晚",
      list: [
        { name: "标准双人房（风扇）", desc: "舒适实用，适合情侣或追求超高性价比的旅行者，就位于圣胡安德尔苏尔的中心地带。", amenities: ["双人床", "独立卫浴", "风扇", "衣柜", "一楼", "Wi-Fi"] },
        { name: "标准双人房 - 空调", desc: "适合追求更多舒适的旅客。在探索海滩和周边后，享受清凉私密的休息空间。", amenities: ["双人床", "空调", "独立卫浴", "挂衣架", "一楼", "Wi-Fi"] },
        { name: "双人房 · 空调 + 共享阳台", desc: "为额外舒适而设计，拥有可放松、阅读与放空的户外空间。", amenities: ["双人床", "空调", "独立卫浴", "挂衣架", "Wi-Fi", "共享阳台"] },
        { name: "三人房", desc: "适合小家庭或结伴出行的朋友——温馨实用，最多可住3人。", amenities: ["双人床 + 单人床", "独立卫浴", "风扇", "大衣柜", "Wi-Fi"] },
        { name: "四人房", desc: "我们最宽敞的房间，适合最多4人的家庭或团体，共享舒适温馨的住宿。", amenities: ["2张单人床 + 1张上下铺", "独立卫浴", "风扇", "Wi-Fi", "宽敞空间", "衣柜"] },
        { name: "标准双人房 - 空调 + 共用阳台", desc: "适合追求更多舒适的旅客。在探索海滩和周边后，享受清凉私密的休息空间。", amenities: ["双人床", "空调", "独立卫浴", "共用阳台", "二楼", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "入住包含",
      title: "让你宾至如归的一切！",
      title2: "今天就来预订入住吧！",
      items: [
        "配有独立卫浴的私人客房",
        "高速Wi-Fi",
        "空调或风扇（视房型而定）",
        "床品、毛巾、卫生纸和肥皂",
        "设备齐全的共享厨房（含咖啡、糖、盐和食用油）",
        "供休息与交流的公共区域",
        "当地推荐与旅游资讯",
        "中心位置：海滩、餐厅、商店与夜生活",
      ],
    },
    location: {
      kicker: "找到我们",
      title: "距 Casa Oro 半个街区，朝海滩方向",
      addressLabel: "地址",
      address: "Zona Central，从 Casa Oro 往海滩方向半个街区，圣胡安德尔苏尔，尼加拉瓜",
      body: "你会在市中心那栋亮紫色、配黄色窗户的建筑里找到我们——步行两分钟即达沙滩。",
      directions: "在 Google 地图中打开",
      whatsapp: "通过 WhatsApp 联系我们",
    },
    reviews: {
      kicker: "住客好评",
      title: "深受旅行者喜爱",
      rating: "4.4",
      count: "基于98条谷歌评价",
      readAll: "查看全部评价",
      leave: "撰写评价",
      items: [
        { name: "背包客 · 加拿大", text: "位置超级中心，私人客房干净整洁，家庭从第一分钟就让我们宾至如归。厨房是一大加分项。" },
        { name: "情侣 · 德国", text: "位置极佳，距海滩半个街区，空调房安静，还有关于冲浪和美食的最佳当地建议。" },
        { name: "独自旅行 · 意大利", text: "温暖、真诚又实惠。正是他们承诺的那种宁静而亲切的体验。我会毫不犹豫再来。" },
      ],
    },
    aboutUs: {
      kicker: "关于我们",
      title: "一个自 2010 年起敞开大门的家",
      body: [
        "我们是一个尼加拉瓜家庭。在旅客需求的推动下，我们于 2010 年决定敞开家门，迎接来自各地的旅行者。",
        "那些年，圣胡安德尔苏尔刚刚开始成为热门旅游目的地，但镇上的住宿十分有限。当时还没有如今的在线预订平台，旅客们只能沿街挨家挨户地打听哪里可以留宿。因为我们的房子很漂亮，常常有人来敲门询问我们是否提供住宿。",
        "于是，我们决定改造自己的家，把它变成了今天的 Casa Romano。从那时起，我们迎接了来自世界各地的客人，让每一次相聚都成为分享与结交朋友的机会。",
        "我们打造了这个空间，让您可以直接联系我们的家庭并预订。",
      ],
    },
    book: {
      title: "预订你的入住",
      sub: "填写你的信息，我们将直接通过 WhatsApp 回复以确认空房情况。",
      name: "全名",
      namePh: "你的姓名",
      checkin: "入住日期",
      checkout: "退房日期",
      guests: "人数",
      room: "房型",
      roomPh: "选择房型",
      roomAny: "无偏好",
      message: "留言（可选）",
      messagePh: "有什么需要我们知道的吗？",
      submit: "发送至 WhatsApp",
      chatDirect: "或直接通过 WhatsApp 联系我们",
      or: "或",
      wa_intro: "你好 Casa Romano！我想申请入住：",
      wa_name: "姓名",
      wa_checkin: "入住",
      wa_checkout: "退房",
      wa_guests: "人数",
      wa_room: "房型",
      wa_msg: "留言",
      availChecking: "正在查询空房…",
      availRangeError: "退房日期必须晚于入住日期。",
      availRoomOk: "{room} 在您选择的日期有空房！",
      availAllOk: "您选择的日期有空房！",
      availRoomFull: "{room} 在这些晚上已订满。请尝试其他日期或与我们联系。",
      availAllFull: "这些晚上我们已订满。请尝试其他日期或通过 WhatsApp 联系我们。",
      availSoldOut: "抱歉，这些日期已订满。请尝试其他日期或通过 WhatsApp 联系我们。",
      availSoldOutBtn: "这些日期已订满",
    },
    footer: {
      tagline: "一个向圣胡安德尔苏尔敞开家门的本地家庭。",
      contactTitle: "联系",
      linksTitle: "探索",
      followTitle: "关注我们",
      ownerLogin: "业主登录",
      rights: "版权所有。",
    },
    wa_float: "联系我们",
  },

  it: {
    nav: { rooms: "Camere", included: "Incluso", story: "La nostra storia", gallery: "Galleria", location: "Posizione", reviews: "Recensioni", book: "Prenota" },
    hero: {
      kicker: "Ostello · San Juan del Sur, Nicaragua",
      titleTW: "La nostra famiglia ti dà il benvenuto a Casa Romano a San Juan del Sur!",
      l1: "Una famiglia locale,",
      l2: "una porta aperta,",
      l3: "la tua casa sul Pacifico.",
      sub: "Camere private con bagno privato, cucina condivisa e consigli locali sinceri — a mezzo isolato dalla spiaggia, nel cuore di San Juan del Sur.",
      book: "Prenota",
      directions: "Indicazioni",
      ratingLabel: "recensioni Google",
    },
    marquee: ["Camere private", "Cucina condivisa", "Spiaggia 2 min", "Famiglia locale", "Wi-Fi gratuito", "San Juan del Sur"],
    story: {
      kicker: "La nostra storia",
      title: "Apriamo la nostra casa a viaggiatori da tutto il mondo.",
      chapters: [
        { n: "01", t: "Una famiglia locale", b: "Casa Romano non è una catena. Siamo una famiglia nicaraguense che apre le porte della propria casa per accogliere i viaggiatori con calore, calma e un benvenuto autentico." },
        { n: "02", t: "Comfort privato", b: "Goditi camere private con bagno privato, Wi-Fi ad alta velocità e una cucina condivisa completamente attrezzata — comfort e indipendenza allo stesso tempo." },
        { n: "03", t: "Il cuore di San Juan", b: "A pochi passi da spiaggia, ristoranti, negozi e vita notturna. Condividiamo i nostri posti preferiti perché tu ti innamori di San Juan del Sur." },
      ],
    },
    rooms: {
      kicker: "Le camere",
      title: "Modi di soggiornare",
      sub: "Ogni camera è privata, con bagno proprio e Wi-Fi ad alta velocità.",
      roomLabel: { one: "camera disponibile", other: "camere disponibili" },
      soldOut: "Esaurito",
      includedLabel: "Incluso",
      extras: ["Lenzuola", "Asciugamani", "Carta igienica", "Sapone"],
      guests: "ospiti",
      book: "Prenota questa camera",
      whatsapp: "Chiedi su WhatsApp",
      perNight: "/ notte",
      list: [
        { name: "Camera Doppia Standard con Ventilatore", desc: "Comoda e funzionale per coppie o viaggiatori in cerca di un ottimo rapporto qualità-prezzo nel pieno centro di San Juan del Sur.", amenities: ["Letto matrimoniale", "Bagno privato", "Ventilatore", "Armadio", "Primo piano", "Wi-Fi"] },
        { name: "Camera Doppia Standard - Aria Condizionata", desc: "Per chi cerca maggior comfort. Uno spazio fresco e privato per riposare dopo aver esplorato le spiagge e i dintorni.", amenities: ["Letto matrimoniale", "Aria condizionata", "Bagno privato", "Appendiabiti", "Primo piano", "Wi-Fi"] },
        { name: "Doppia · A/C + Balcone Condiviso", desc: "Pensata per un comfort extra e uno spazio all'aperto per rilassarti, leggere e staccare durante il soggiorno.", amenities: ["Letto matrimoniale", "Aria condizionata", "Bagno privato", "Appendiabiti", "Wi-Fi", "Balcone condiviso"] },
        { name: "Camera Tripla", desc: "Perfetta per piccole famiglie o amici in viaggio insieme — uno spazio accogliente e pratico fino a 3 persone.", amenities: ["Letto matrimoniale + letto singolo", "Bagno privato", "Ventilatore", "Grande armadio", "Wi-Fi"] },
        { name: "Camera Quadrupla", desc: "La nostra camera più ampia, ideale per famiglie o gruppi fino a 4 persone che vogliono condividere un soggiorno confortevole.", amenities: ["2 letti singoli + 1 letto a castello", "Bagno privato", "Ventilatore", "Wi-Fi", "Spazio ampio", "Armadio"] },
        { name: "Camera Doppia Standard - Aria Condizionata + Balcone condiviso", desc: "Per chi cerca maggior comfort. Uno spazio fresco e privato per riposare dopo aver esplorato le spiagge e i dintorni.", amenities: ["Letto matrimoniale", "Aria condizionata", "Bagno privato", "Balcone condiviso", "Secondo piano", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "Incluso nel soggiorno",
      title: "Tutto ciò che serve per sentirti a casa!",
      title2: "Prenota oggi il tuo soggiorno da noi!",
      items: [
        "Camera privata con bagno privato",
        "Wi-Fi ad alta velocità",
        "Aria condizionata o ventilatore (secondo la camera)",
        "Lenzuola, asciugamani, carta igienica e sapone",
        "Cucina condivisa attrezzata (caffè, zucchero, sale e olio inclusi)",
        "Aree comuni per riposare e socializzare",
        "Consigli locali e informazioni turistiche",
        "Posizione centrale: spiaggia, ristoranti, negozi e vita notturna",
      ],
    },
    location: {
      kicker: "Trovaci",
      title: "A mezzo isolato da Casa Oro, verso la spiaggia",
      addressLabel: "Indirizzo",
      address: "Zona Central, da Casa Oro mezzo isolato verso la spiaggia, San Juan del Sur, Nicaragua",
      body: "Ci trovi nell'edificio viola acceso con le finestre gialle, in pieno centro — a due minuti a piedi dalla sabbia.",
      directions: "Apri in Google Maps",
      whatsapp: "Scrivici su WhatsApp",
    },
    reviews: {
      kicker: "I nostri ospiti",
      title: "Amato dai viaggiatori",
      rating: "4.4",
      count: "Basato su 98 recensioni Google",
      readAll: "Leggi tutte le recensioni",
      leave: "Lascia una recensione",
      items: [
        { name: "Backpacker · Canada", text: "Super centrale, camera privata impeccabile e la famiglia ci ha fatto sentire a casa dal primo minuto. La cucina è un grande plus." },
        { name: "Coppia · Germania", text: "Ottima posizione a mezzo isolato dalla spiaggia, camera con A/C tranquilla e i migliori consigli locali per surf e cibo." },
        { name: "Viaggiatrice sola · Italia", text: "Caloroso, onesto ed economico. Esattamente l'esperienza tranquilla e vicina che promettono. Ci tornerei senza pensarci." },
      ],
    },
    aboutUs: {
      kicker: "Chi siamo",
      title: "Una casa di famiglia, aperta dal 2010",
      body: [
        "Siamo una famiglia nicaraguense che, spinta dalla richiesta, nel 2010 ha deciso di aprire le porte della propria casa ai viaggiatori.",
        "In quegli anni San Juan del Sur stava appena iniziando a diventare una meta conosciuta, ma le sistemazioni in paese erano poche. Poiché le piattaforme di prenotazione di oggi non esistevano ancora, i viaggiatori giravano per le strade bussando di casa in casa in cerca di un posto dove dormire. Alla nostra bussavano spesso, attratti dalla bellezza del nostro spazio.",
        "Fu così che decidemmo di adattare la nostra casa per trasformarla in quella che oggi è Casa Romano. Da allora accogliamo persone da tutto il mondo, trasformando ogni visita in un'occasione per condividere e fare amicizia.",
        "Abbiamo creato questo spazio perché tu possa contattarci e prenotare direttamente con la nostra famiglia.",
      ],
    },
    book: {
      title: "Richiedi il tuo soggiorno",
      sub: "Inserisci i tuoi dati e ti risponderemo direttamente su WhatsApp per confermare la disponibilità.",
      name: "Nome completo",
      namePh: "Il tuo nome",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Ospiti",
      room: "Tipo di camera",
      roomPh: "Scegli una camera",
      roomAny: "Nessuna preferenza",
      message: "Messaggio (facoltativo)",
      messagePh: "Qualcosa che dovremmo sapere?",
      submit: "Invia su WhatsApp",
      chatDirect: "Oppure scrivici direttamente su WhatsApp",
      or: "oppure",
      wa_intro: "Ciao Casa Romano! Vorrei richiedere un soggiorno:",
      wa_name: "Nome",
      wa_checkin: "Check-in",
      wa_checkout: "Check-out",
      wa_guests: "Ospiti",
      wa_room: "Camera",
      wa_msg: "Messaggio",
      availChecking: "Verifica disponibilità…",
      availRangeError: "Il check-out deve essere dopo il check-in.",
      availRoomOk: "{room} è disponibile per le tue date!",
      availAllOk: "Ci sono camere disponibili per le tue date!",
      availRoomFull: "{room} è al completo per queste notti. Prova altre date o scrivici.",
      availAllFull: "Siamo al completo per queste notti. Prova altre date o scrivici su WhatsApp.",
      availSoldOut: "Spiacenti, queste date sono al completo. Prova altre date o scrivici su WhatsApp.",
      availSoldOutBtn: "Esaurito per queste date",
    },
    footer: {
      tagline: "Una famiglia locale che apre le sue porte a San Juan del Sur.",
      contactTitle: "Contatti",
      linksTitle: "Esplora",
      ownerLogin: "Accesso proprietario",
      followTitle: "Seguici",
      rights: "Tutti i diritti riservati.",
    },
    wa_float: "Scrivici",
  },

  pt: {
    nav: { rooms: "Quartos", included: "Incluído", story: "Nossa história", gallery: "Galeria", location: "Localização", reviews: "Avaliações", book: "Reservar" },
    hero: {
      kicker: "Hostel · San Juan del Sur, Nicarágua",
      titleTW: "A nossa família dá-lhe as boas-vindas à Casa Romano em San Juan del Sur!",
      l1: "Uma família local,",
      l2: "uma porta aberta,",
      l3: "o seu lar no Pacífico.",
      sub: "Quartos privativos com banheiro próprio, cozinha compartilhada e dicas locais sinceras — a meia quadra da praia, no coração de San Juan del Sur.",
      book: "Reservar",
      directions: "Como chegar",
      ratingLabel: "avaliações no Google",
    },
    marquee: ["Quartos privativos", "Cozinha compartilhada", "Praia a 2 min", "Família local", "Wi-Fi grátis", "San Juan del Sur"],
    story: {
      kicker: "Nossa história",
      title: "Abrimos o nosso lar a viajantes de todo o mundo.",
      chapters: [
        { n: "01", t: "Uma família local", b: "A Casa Romano não é uma rede. Somos uma família nicaraguense que abre as portas do seu lar para receber viajantes com carinho, calma e um acolhimento genuíno." },
        { n: "02", t: "Conforto privativo", b: "Desfrute de quartos privativos com banheiro próprio, Wi-Fi de alta velocidade e uma cozinha compartilhada totalmente equipada — conforto e independência ao mesmo tempo." },
        { n: "03", t: "O coração de San Juan", b: "A poucos passos da praia, restaurantes, lojas e vida noturna. Compartilhamos os nossos lugares favoritos para você se apaixonar por San Juan del Sur." },
      ],
    },
    rooms: {
      kicker: "Os quartos",
      title: "Formas de ficar",
      sub: "Cada quarto é privativo, com banheiro próprio e Wi-Fi de alta velocidade.",
      roomLabel: { one: "quarto disponível", other: "quartos disponíveis" },
      soldOut: "Esgotado",
      includedLabel: "Incluído",
      extras: ["Roupa de cama", "Toalhas", "Papel higiénico", "Sabonete"],
      guests: "hóspedes",
      book: "Reservar este quarto",
      whatsapp: "Perguntar no WhatsApp",
      perNight: "/ noite",
      list: [
        { name: "Quarto Duplo Standard com Ventilador", desc: "Confortável e funcional para casais ou viajantes que buscam ótimo custo-benefício no centro de San Juan del Sur.", amenities: ["Cama de casal", "Banheiro privativo", "Ventilador", "Guarda-roupa", "Primeiro andar", "Wi-Fi"] },
        { name: "Quarto Duplo Standard - Ar-Condicionado", desc: "Para quem busca mais conforto. Um espaço fresco e privativo para descansar depois de explorar as praias e os arredores.", amenities: ["Cama de casal", "Ar-condicionado", "Banheiro privativo", "Cabideiro", "Primeiro andar", "Wi-Fi"] },
        { name: "Duplo · A/C + Varanda Compartilhada", desc: "Pensado para um conforto extra e um espaço ao ar livre para relaxar, ler e desconectar durante a estadia.", amenities: ["Cama de casal", "Ar-condicionado", "Banheiro privativo", "Cabideiro", "Wi-Fi", "Varanda compartilhada"] },
        { name: "Quarto Triplo", desc: "Perfeito para pequenas famílias ou amigos viajando juntos — um espaço aconchegante e prático para até 3 pessoas.", amenities: ["Cama de casal + cama de solteiro", "Banheiro privativo", "Ventilador", "Guarda-roupa amplo", "Wi-Fi"] },
        { name: "Quarto Quádruplo", desc: "Nosso quarto mais amplo, ideal para famílias ou grupos de até 4 pessoas que querem compartilhar uma estadia confortável.", amenities: ["2 camas de solteiro + 1 beliche", "Banheiro privativo", "Ventilador", "Wi-Fi", "Espaço amplo", "Guarda-roupa"] },
        { name: "Quarto Duplo Standard - Ar-Condicionado + Varanda compartilhada", desc: "Para quem busca mais conforto. Um espaço fresco e privativo para descansar depois de explorar as praias e os arredores.", amenities: ["Cama de casal", "Ar-condicionado", "Banheiro privativo", "Varanda compartilhada", "Segundo andar", "Wi-Fi"] },
      ],
    },
    included: {
      kicker: "Incluído na sua estadia",
      title: "Tudo o que precisa para se sentir em casa!",
      title2: "Reserve hoje a sua estadia connosco!",
      items: [
        "Quarto privativo com banheiro próprio",
        "Wi-Fi de alta velocidade",
        "Ar-condicionado ou ventilador (conforme o quarto)",
        "Roupa de cama, toalhas, papel higiênico e sabonete",
        "Cozinha compartilhada equipada (café, açúcar, sal e óleo incluídos)",
        "Áreas comuns para descansar e socializar",
        "Recomendações locais e informações turísticas",
        "Localização central: praia, restaurantes, lojas e vida noturna",
      ],
    },
    location: {
      kicker: "Encontre-nos",
      title: "A meia quadra da Casa Oro, em direção à praia",
      addressLabel: "Endereço",
      address: "Zona Central, da Casa Oro meia quadra em direção à praia, San Juan del Sur, Nicarágua",
      body: "Você nos encontra no vibrante prédio roxo com janelas amarelas, bem no centro — a dois minutos a pé da areia.",
      directions: "Abrir no Google Maps",
      whatsapp: "Fale conosco no WhatsApp",
    },
    reviews: {
      kicker: "Nossos hóspedes",
      title: "Amado pelos viajantes",
      rating: "4.4",
      count: "Baseado em 98 avaliações do Google",
      readAll: "Ver todas as avaliações",
      leave: "Deixar uma avaliação",
      items: [
        { name: "Mochileiro · Canadá", text: "Super central, quarto privativo impecável e a família nos fez sentir em casa desde o primeiro minuto. A cozinha é um grande diferencial." },
        { name: "Casal · Alemanha", text: "Ótima localização a meia quadra da praia, quarto com A/C silencioso e as melhores dicas locais para surfe e comida." },
        { name: "Viajante solo · Itália", text: "Acolhedor, honesto e acessível. Exatamente a experiência tranquila e próxima que prometem. Voltaria sem pensar duas vezes." },
      ],
    },
    aboutUs: {
      kicker: "Sobre nós",
      title: "Uma casa de família, aberta desde 2010",
      body: [
        "Somos uma família nicaraguense que, impulsionada pela procura, decidiu abrir as portas da sua casa aos viajantes em 2010.",
        "Naqueles anos, San Juan del Sur começava a tornar-se um destino cada vez mais conhecido, mas a oferta de hospedagem na vila era limitada. Como ainda não existiam as plataformas de reserva de hoje, os viajantes percorriam as ruas perguntando de casa em casa por um lugar para ficar. À nossa, em especial, chegavam com frequência, atraídos pela beleza do nosso espaço.",
        "Foi assim que decidimos adaptar a nossa casa e transformá-la no que hoje é a Casa Romano. Desde então, recebemos pessoas de todo o mundo, transformando cada visita numa oportunidade de partilhar e fazer amizades.",
        "Criámos este espaço para que possa contactar-nos e reservar diretamente com a nossa família.",
      ],
    },
    book: {
      title: "Solicite sua estadia",
      sub: "Preencha seus dados e responderemos diretamente no WhatsApp para confirmar a disponibilidade.",
      name: "Nome completo",
      namePh: "Seu nome",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Hóspedes",
      room: "Tipo de quarto",
      roomPh: "Escolha um quarto",
      roomAny: "Sem preferência",
      message: "Mensagem (opcional)",
      messagePh: "Algo que devemos saber?",
      submit: "Enviar no WhatsApp",
      chatDirect: "Ou fale direto no WhatsApp",
      or: "ou",
      wa_intro: "Olá Casa Romano! Gostaria de solicitar uma estadia:",
      wa_name: "Nome",
      wa_checkin: "Check-in",
      wa_checkout: "Check-out",
      wa_guests: "Hóspedes",
      wa_room: "Quarto",
      wa_msg: "Mensagem",
      availChecking: "Verificando disponibilidade…",
      availRangeError: "A saída deve ser depois da entrada.",
      availRoomOk: "{room} está disponível para as suas datas!",
      availAllOk: "Há quartos disponíveis para as suas datas!",
      availRoomFull: "{room} está esgotado nessas noites. Tente outras datas ou fale conosco.",
      availAllFull: "Estamos esgotados nessas noites. Tente outras datas ou fale conosco no WhatsApp.",
      availSoldOut: "Desculpe, essas datas estão esgotadas. Tente outras datas ou fale conosco no WhatsApp.",
      availSoldOutBtn: "Esgotado nessas datas",
    },
    footer: {
      tagline: "Uma família local que abre as portas para San Juan del Sur.",
      contactTitle: "Contato",
      ownerLogin: "Acesso do proprietário",
      linksTitle: "Explorar",
      followTitle: "Siga-nos",
      rights: "Todos os direitos reservados.",
    },
    wa_float: "Fale conosco",
  },
};
